/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-unescaped-entities */

import React from 'react'
import axios from 'axios'

// mui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { cmToInches, inchesToCm } from './globalHelpers'
import { returnSquareImage, returnSquareVideoThumbnail, fileToDataURL, getStartCropImageWidthsAndHeights, getStartCropVideoWidthsAndHeights, returnDurationFromLiveURL, returnVideoThumbnailFromLiveURL } from './imageHandling'
import { scorecardPointsObj, maximumMediaSize, maximumMediaItems, minimumBumbleAboutMe, minimumBumbleHobbies, minimumBumbleMedia, minimumBumblePrompts, minimumHingeAboutMe, minimumHingeHobbies, minimumHingeMedia, minimumHingePrompts, minimumTinderAboutMe, minimumTinderHobbies, minimumTinderMedia, minimumTinderPrompts, minimumOnboardingAboutMe, minimumOnboardingHobbies, minimumOnboardingMedia, minimumOnboardingPrompts, requiredVitalInfoArray, swipelyticsPink, swipelyticsTurquoise } from './variableDefaults'

// ? Vital Info

export const vitalInfoSetChanges = (e, setErrors, setForm, form, name, value, vitalInfoObject) => {
  if (name === 'heightInches' || name === 'heightCM') {
    setForm({ 
      ...form, 
      heightInches: vitalInfoObject.inOrCmPreference === 'in' ? value : cmToInches(value),
      heightCM: vitalInfoObject.inOrCmPreference === 'cm' ? value : inchesToCm(value),
    })
  } else if (Array.isArray(value) && value.length === 2 && name === 'interestedInAge') {
    setForm({ 
      ...form, 
      interestedInAgeMin: value[0],
      interestedInAgeMax: value[1],
    })
  } else if (Array.isArray(value)) {
    if (value[value.length - 1] === 'Prefer not to say') {
      setForm({ 
        ...form, 
        [name]: ['Prefer not to say'], 
      })
    } else if (value.length > 1) {
      // const newValue = value.filter(text => text !== 'Prefer not to say')
      // console.log('newValue ->', newValue)
      setForm({ 
        ...form, 
        [name]: value.filter(text => text !== 'Prefer not to say'), 
      })
    } else if (name !== 'languages' || value.length <= 6) {
      setForm({ 
        ...form, 
        [name]: value, 
      })
    }
  } else if (value.length === 0 || (value.length > 0 && typeof value === 'string' && value.charAt(0) !== ' ') || typeof value === 'number') {
    // console.log('form should set')
    setForm({ 
      ...form, 
      [name]: value, 
    })
  }
}


// ? Media // No longer used because it doesn't account for image cropping
export const handleImageSelectNewMedia = async (e, mediaArray, setMediaArray, setLoadingMedia, setMediaErrors, previousMediaLength = 0) => {
  // console.log('e.target.files.length ->', e.target.files[0])
  if (e.target.files.length > 0) {
    // Set errors to false and loading to true
    setMediaErrors(false)
    setLoadingMedia(true)

    // Center image and crop it into a 600x600 jpg; save a dataURL onto the formdata as profilePicture
    const newMediaArray = []
    const arrayIterations = (e.target.files.length < (maximumMediaItems - mediaArray.length - previousMediaLength)) ? e.target.files.length : (maximumMediaItems - mediaArray.length - previousMediaLength)
    // console.log('arrayIterations ->', arrayIterations)
    for (let i = 0; i < arrayIterations; i++) {
      // console.log('i ->', i)
      // console.log('file ->', e.target.files[i])
      if (e.target.files[i].size < maximumMediaSize) { // less than 50MB
        if (e.target.files[i].type.includes('image')) {
          
          const newSquareImage = await returnSquareImage(e.target.files[i])
          newMediaArray.push({ 
            file: e.target.files[i], 
            squareImage: newSquareImage, 
            duration: -1,
            imageOrVideo: 'image',  
            // nameOfFile: `${user.email.slice(0, user.email.indexOf('@'))}-${Date.now()}`,
            // bucketType: 'client',
          })
        } else if (e.target.files[i].type.includes('video')) {
          // console.log('video file')
          const newSquareVideoThumbnailAndDurationObj = await returnSquareVideoThumbnail(e.target.files[i])
          // const videoFileDataUrl = await fileToDataURL(e.target.files[i])
          // console.log('videoFileDataUrl ->', videoFileDataUrl)
          console.log('newSquareVideoThumbnailAndDurationObj ->', newSquareVideoThumbnailAndDurationObj)
          if (typeof newSquareVideoThumbnailAndDurationObj !== 'string' ) {
            newMediaArray.push({ 
              file: e.target.files[i], 
              squareImage: newSquareVideoThumbnailAndDurationObj.squareImage, 
              duration: newSquareVideoThumbnailAndDurationObj.duration,
              imageOrVideo: 'video', 
              // nameOfFile: `${user.email.slice(0, user.email.indexOf('@'))}-${Date.now()}`,
              // bucketType: 'client',
            })
          } else {
            console.log('video error ->', newSquareVideoThumbnailAndDurationObj)
            setMediaErrors(true)
          }
        }
      } else {
        console.log('file too large ->', e.target.files[i].size)
        setMediaErrors(true)
      }
      
    }
    const arrayToSet = [ ...mediaArray, ...newMediaArray ].slice(0, maximumMediaItems)
    // console.log('arrayToSet ->', arrayToSet)

    setMediaArray(arrayToSet)
  
    setLoadingMedia(false)
  }
}

// ? Selected New Media and Shaping an Object to Prepare for Image Cropping
export const handleImageSelectNewMediaPrepareForCrop = async (e, mediaArray, setMediaArray, setShowCropCarousel, setLoadingMedia, setMediaErrors, previousMediaLength = 0) => {
  // console.log('e.target.files.length ->', e.target.files[0])
  if (e.target.files.length > 0) {
    // Set errors to false and loading to true
    setMediaErrors(false)
    setLoadingMedia(true)

    let newMediaArray = []
    const arrayIterations = (e.target.files.length < (maximumMediaItems - mediaArray.length - previousMediaLength)) ? e.target.files.length : (maximumMediaItems - mediaArray.length - previousMediaLength)
    // console.log('arrayIterations ->', arrayIterations)
    for (let i = 0; i < arrayIterations; i++) {
      // console.log('i ->', i)
      // console.log('file ->', e.target.files[i])
      if (
        e.target.files[i].size < maximumMediaSize // less than max file size
        &&
        (
          e.target.files[i].type.includes('image') 
          || e.target.files[i].type.includes('video')
        )
      ) { 
        // console.log('file size ->', e.target.files[i].size)
        // console.log('maximumMediaSize ->', maximumMediaSize)
        const fileType = e.target.files[i].type.includes('image') ? 'image' : 'video'
        // console.log('fileType ->', fileType)
        
        const fileDataURL = await fileToDataURL(e.target.files[i])
        // console.log('fileDataURL')
        const mediaStartCropWidthsAndHeightsObj = fileType === 'image' ? await getStartCropImageWidthsAndHeights(fileDataURL) : await getStartCropVideoWidthsAndHeights(e.target.files[i])
        console.log('mediaStartCropWidthsAndHeightsObj')

        newMediaArray.push({ 

          file: e.target.files[i], 
          dataURL: fileDataURL,
          videoThumbnailURL: 'NA',
          duration: -1,
          imageOrVideo: fileType,  

          squareCrop: {
            x: 0,
            y: 0, 
            width: mediaStartCropWidthsAndHeightsObj.squareImageWidth,
            height: mediaStartCropWidthsAndHeightsObj.squareImageHeight,
          },
          squareCropDataURL: '',

          portraitCrop: {
            x: 0,
            y: 0, 
            width: mediaStartCropWidthsAndHeightsObj.portraitImageWidth,
            height: mediaStartCropWidthsAndHeightsObj.portraitImageHeight,
          },
          portraitCropDataURL: '',
        })
      } else {
        console.log('file too large ->', e.target.files[i].size)
        newMediaArray = []
        setMediaErrors(true)
  
        setShowCropCarousel(false)
        setLoadingMedia(false)
        return
      }
      
    }
    const arrayToSet = [ ...mediaArray, ...newMediaArray ].slice(0, maximumMediaItems).sort((a,b) => a.imageOrVideo.localeCompare(b.imageOrVideo))
    // console.log('arrayToSet ->', arrayToSet)
    
    setMediaArray(arrayToSet)

    if (newMediaArray.length > 0) {
      setShowCropCarousel(true)
    }
  
    setLoadingMedia(false)
  }
}

// ? No longer used — doesn't account for media cropping
export const handleImageSelectUpdateMedia = async (e, mediaItem, setMediaItem, previousMediaItem, updatedMediaItemObj, setUpdatedMediaItemObj, loading, setLoading, errors, setErrors) => {

  if (e.target.files.length > 0) {
    // Set errors to false and loading to true
    setErrors({ ...errors, image: false })
    setLoading({ ...loading, image: true })

    // Center image and crop it into a 600x600 jpg; save a dataURL onto the formdata as profilePicture

    if (e.target.files[0].size < maximumMediaSize) { // less than 50MB
      if (e.target.files[0].type.includes('image') && mediaItem.type === 'image') {
        
        const newSquareImage = await returnSquareImage(e.target.files[0])
        setUpdatedMediaItemObj({
          ...updatedMediaItemObj,
          file: e.target.files[0],
          fileName: `${mediaItem.email.slice(0, mediaItem.email.indexOf('@'))}`,
          squareImage: newSquareImage,
          duration: -1,
          mediaType: 'image',  
          urlString: mediaItem.url,
          bucketType: 'client',
          userId: mediaItem.userId, 
          email: mediaItem.email,
          mediaItemId: mediaItem._id,
        })

        setMediaItem({ ...mediaItem, url: newSquareImage })
        // console.log('newSquareImage ->', newSquareImage)

      } else if (e.target.files[0].type.includes('video') && mediaItem.type === 'video') {
        // console.log('video file')
        const newSquareVideoThumbnailAndDurationObj = await returnSquareVideoThumbnail(e.target.files[0])
        // const videoFileDataUrl = await fileToDataURL(e.target.files[i])
        // console.log('videoFileDataUrl ->', videoFileDataUrl)
        // console.log('newSquareVideoThumbnailAndDurationObj ->', newSquareVideoThumbnailAndDurationObj)
        if (typeof newSquareVideoThumbnailAndDurationObj !== 'string' ) {
          setUpdatedMediaItemObj({
            ...updatedMediaItemObj,
            file: e.target.files[0], 
            fileName: `${mediaItem.email.slice(0, mediaItem.email.indexOf('@'))}`,
            squareImage: newSquareVideoThumbnailAndDurationObj.squareImage, 
            duration: newSquareVideoThumbnailAndDurationObj.duration,
            mediaType: 'video',  
            urlString: previousMediaItem.url,
            bucketType: 'client',
            userId: mediaItem.userId, 
            email: mediaItem.email,
            mediaItemId: mediaItem._id,
          })

          setMediaItem({ ...mediaItem, url: newSquareVideoThumbnailAndDurationObj.squareImage })
          console.log('new square video thumbnail', newSquareVideoThumbnailAndDurationObj.squareImage)
        } else {
          console.log('video error ->', newSquareVideoThumbnailAndDurationObj)
          setErrors({ ...errors, image: true })
        }
      } else {
        console.log('Invalid media type')
        setErrors({ ...errors, image: true })
      }
    } else {
      console.log('file too large ->', e.target.files[0].size)
      setErrors({ ...errors, image: true })
    }
  
    setLoading({ ...loading, image: false })
  }
}

// ? Updating media items for all aspect ratios
export const handleImageSelectUpdateMediaCrop = async (e, mediaItem, setMediaItem, previousMediaItem, updatedMediaItemObj, setUpdatedMediaItemObj, loading, setLoading, errors, setErrors) => {

  if (e.target.files.length > 0) {
    // Set errors to false and loading to true
    setErrors({ ...errors, image: false })
    setLoading({ ...loading, image: true })

    if (
      e.target.files[0].size < maximumMediaSize // less than maximum accepted size
      &&
      (
        e.target.files[0].type.includes('image') 
        || e.target.files[0].type.includes('video')
      )
    ) {
      const fileType = e.target.files[0].type.includes('image') ? 'image' : 'video'
      // console.log('fileType ->', fileType)
      
      const fileDataURL = await fileToDataURL(e.target.files[0])
      // console.log('fileDataURL')
      const mediaStartCropWidthsAndHeightsObj = fileType === 'image' ? await getStartCropImageWidthsAndHeights(fileDataURL) : await getStartCropVideoWidthsAndHeights(e.target.files[0])
      // console.log('mediaStartCropWidthsAndHeightsObj')

      setUpdatedMediaItemObj({
        ...updatedMediaItemObj,

        file: e.target.files[0],
        dataURL: fileDataURL,
        fileName: `${mediaItem.email.slice(0, mediaItem.email.indexOf('@'))}`,
        videoThumbnailURLString: 'videoThumbnailURL' in mediaItem ? mediaItem.videoThumbnailURL : 'NA', 
        duration: -1,
        mediaType: fileType,

        squareURLString: mediaItem.url,
        squareCrop: {
          x: 0,
          y: 0, 
          width: mediaStartCropWidthsAndHeightsObj.squareImageWidth,
          height: mediaStartCropWidthsAndHeightsObj.squareImageHeight,
        },
        squareCropDataURL: '',

        portraitURLString: mediaItem.portraitURL,
        portraitCrop: {
          x: 0,
          y: 0, 
          width: mediaStartCropWidthsAndHeightsObj.portraitImageWidth,
          height: mediaStartCropWidthsAndHeightsObj.portraitImageHeight,
        },
        portraitCropDataURL: '',

        bucketType: 'client',
        userId: mediaItem.userId, 
        email: mediaItem.email,
        mediaItemId: mediaItem._id,
      })

    } else {
      console.log('file too large ->', e.target.files[0].size)
      setErrors({ ...errors, image: true })
    }
  
    setLoading({ ...loading, image: false })
  }
}

// ? Set Video Thumbnail — Dating Profiles
export const handleSetVideoThumbnailDatingProfile = (datingProfile, mediaItemIndex, setVideoThumbnail, setVideoDuration) => {
  if (
    'mediaItemThumbnail' in datingProfile.media[mediaItemIndex] && datingProfile.media[mediaItemIndex].mediaItemThumbnail.length > 0 && datingProfile.media[mediaItemIndex].mediaItemThumbnail !== 'NA'
    && 'mediaItemDuration' in datingProfile.media[mediaItemIndex]
  ) {
    // console.log('thumbnail and duration in media item')
    setVideoDuration(datingProfile.media[mediaItemIndex].mediaItemDuration)
    setVideoThumbnail(datingProfile.media[mediaItemIndex].mediaItemThumbnail)
  } else if (
    'mediaItemThumbnail' in datingProfile.media[mediaItemIndex] && datingProfile.media[mediaItemIndex].mediaItemThumbnail.length > 0 && datingProfile.media[mediaItemIndex].mediaItemThumbnail !== 'NA'
  ) {
    // console.log('thumbnail but not duration in media item')
    returnDurationFromLiveURL(datingProfile.media[mediaItemIndex].mediaItemURL, setVideoDuration)
    setVideoThumbnail(datingProfile.media[mediaItemIndex].mediaItemThumbnail)
  } else {
    returnVideoThumbnailFromLiveURL(datingProfile.media[mediaItemIndex].mediaItemURL, setVideoThumbnail, setVideoDuration)
  }
}

// ? Set Video Thumbnail — Media Items
export const handleSetVideoThumbnailMediaItem = (mediaItem, setVideoThumbnail, setVideoDuration) => {
  if (
    'videoThumbnailURL' in mediaItem && mediaItem.videoThumbnailURL.length > 0 && mediaItem.videoThumbnailURL !== 'NA'
    && 'duration' in mediaItem
  ) {
    // console.log('thumbnail and duration in media item')
    setVideoDuration(mediaItem.duration)
    setVideoThumbnail(mediaItem.videoThumbnailURL)
  } else if (
    'videoThumbnailURL' in mediaItem && mediaItem.videoThumbnailURL.length > 0 && mediaItem.videoThumbnailURL !== 'NA'
  ) {
    // console.log('thumbnail but not duration in media item')
    returnDurationFromLiveURL(mediaItem.url, setVideoDuration)
    setVideoThumbnail(mediaItem.videoThumbnailURL)
  } else {
    returnVideoThumbnailFromLiveURL(mediaItem.url, setVideoThumbnail, setVideoDuration)
  }
}


// ? Bio Elements (About Me, Prompts, Hobbies)


// ? Profiles
export const requiredVitalInfoExists = (vitalInfoObj) => {
  return requiredVitalInfoArray.filter(vitalInfoKey => (typeof vitalInfoObj[vitalInfoKey] === 'string' && vitalInfoObj[vitalInfoKey].length > 0) || (typeof vitalInfoObj[vitalInfoKey] === 'number' && vitalInfoObj[vitalInfoKey] > 0)).length === requiredVitalInfoArray.length
}

export const profileIsCompleted = (profile) => {
  // console.log('profile.bio.hobbies.length ->', profile.bio.hobbies.length)
  
  if (profile.type === 'hinge') {
    return (
      profile.media.length >= minimumHingeMedia 
      && profile.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length >= minimumHingePrompts
      && requiredVitalInfoExists(profile.bio.vitalInfo)
    )
  } else if (profile.type === 'bumble') {
    return (
      profile.media.length >= minimumBumbleMedia 
      && profile.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length >= minimumBumblePrompts
      && profile.bio.aboutMe.length >= minimumBumbleAboutMe
      && requiredVitalInfoExists(profile.bio.vitalInfo)
    )
  } else if (profile.type === 'tinder') {
    return (
      profile.media.length >= minimumTinderMedia 
      && profile.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length >= minimumTinderPrompts
      && profile.bio.aboutMe.length >= minimumTinderAboutMe
      && profile.bio.hobbies.filter(hobbyItem => hobbyItem.length > 0).length >= minimumTinderHobbies
      && requiredVitalInfoExists(profile.bio.vitalInfo)
    )
  } else {
    return false
  }
}

export const newProfileCriteriaIsMet = (user) => {
  return (

    // User Exists
    user 
    && user !== null 

    // Media Items 
    && 'media' in user
    && user.media !== null
    && user.media.length >= minimumOnboardingMedia

    // Bio Exists
    && 'bio' in user
    && user.bio !== null

    // Vital Info — First Name, Age, Gender, Interested In, Height
    && 'vitalInfo' in user.bio
    && user.bio.vitalInfo !== null
    && Object.keys(user.bio.vitalInfo).length > 0
    && requiredVitalInfoExists(user.bio.vitalInfo)

    // About Me
    && 'aboutMe' in user.bio
    && user.bio.aboutMe.length >= minimumOnboardingAboutMe
    && user.bio.aboutMe.filter(aboutMeItem => aboutMeItem.length > 0).length >= minimumOnboardingAboutMe

    // Prompts
    && 'prompts' in user.bio
    && user.bio.prompts.length >= minimumOnboardingPrompts 
    && user.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length >= minimumOnboardingPrompts

    // Hobbies
    && 'hobbies' in user.bio
    && user.bio.hobbies.length >= minimumOnboardingHobbies
    && user.bio.hobbies.filter(hobbyItem => hobbyItem.length > 0).length >= minimumOnboardingHobbies

  )
}


// ? Scorecard
export const mediaScore = (mediaFeedbackArray) => {
  // console.log('mediaFeedbackArray ->', mediaFeedbackArray)
  let mediaFeedbackCurrentScore = 0

  // console.log('mediaFeedbackArray ->', mediaFeedbackArray)
  for (let i = 0; i < mediaFeedbackArray.length; i++) {
    const lowercaseVerdict = mediaFeedbackArray[i].verdict.toLowerCase()
    if (lowercaseVerdict === 'very' || lowercaseVerdict === 'yes' || lowercaseVerdict === 'somewhat' || lowercaseVerdict === 'no') {
      mediaFeedbackCurrentScore = mediaFeedbackCurrentScore + scorecardPointsObj.media[lowercaseVerdict]
    }
  }

  return mediaFeedbackCurrentScore
}

export const aboutMeScore = (profileType, bioFeedbackObj) => {

  let aboutMeCurrentScore = 0

  if (profileType !== 'hinge') {
    const lowercaseVerdict = bioFeedbackObj.aboutMeFeedback.verdict.toLowerCase()
    if (lowercaseVerdict === 'very' || lowercaseVerdict === 'yes' || lowercaseVerdict === 'somewhat' || lowercaseVerdict === 'no') {
      aboutMeCurrentScore = aboutMeCurrentScore + scorecardPointsObj.aboutMe[lowercaseVerdict]
    }
  }

  return aboutMeCurrentScore
} 

export const promptsScore = (bioFeedbackObj) => {
  let promptsFeedbackCurrentScore = 0

  for (let i = 0; i < bioFeedbackObj.promptsFeedback.length; i++) {
    const lowercaseVerdict = bioFeedbackObj.promptsFeedback[i].verdict.toLowerCase()
    if (lowercaseVerdict === 'very' || lowercaseVerdict === 'yes' || lowercaseVerdict === 'somewhat' || lowercaseVerdict === 'no') {
      promptsFeedbackCurrentScore = promptsFeedbackCurrentScore + scorecardPointsObj.prompts[lowercaseVerdict]
    }
  }

  return promptsFeedbackCurrentScore
} 

export const vitalInfoScore = (bioFeedbackObj) => {

  let vitalInfoCurrentScore = 0

  const lowercaseVerdict = bioFeedbackObj.vitalInfoFeedback.verdict.toLowerCase()
  if (lowercaseVerdict === 'very' || lowercaseVerdict === 'yes' || lowercaseVerdict === 'somewhat' || lowercaseVerdict === 'no') {
    vitalInfoCurrentScore = vitalInfoCurrentScore + scorecardPointsObj.vitalInfo[lowercaseVerdict]
  }

  return vitalInfoCurrentScore
}

export const bioScore = (profileType, bioFeedbackObj) => {
  return promptsScore(bioFeedbackObj) + vitalInfoScore(bioFeedbackObj) + aboutMeScore(profileType, bioFeedbackObj)
} 

export const totalScore = (profileType, mediaFeedbackArray, bioFeedbackObj) => {
  

  return mediaScore(mediaFeedbackArray) + bioScore(profileType, bioFeedbackObj)
}

export const totalGrade = (finalScore) => {
  return finalScore > 14 ? 'ELITE' : finalScore > 9 ? 'VERY GOOD' : finalScore > 4 ? 'GOOD' : finalScore > 0 ? 'PASSABLE' : 'NEEDS WORK'
}

export const totalGradeColor = (fromComponent , finalGrade) => {

  return fromComponent === 'scorecard' 
    ?
    finalGrade.toLowerCase() === 'needs work' ? swipelyticsPink : finalGrade.toLowerCase() === 'passable' ? 'lightblue' : swipelyticsTurquoise
    :
    fromComponent === 'reviewCard' ?
      finalGrade.toLowerCase() === 'needs work' ? 'red' : finalGrade.toLowerCase() === 'passable' ? 'dimgray' : finalGrade.toLowerCase() === 'good' ? 'cadetblue' : finalGrade.toLowerCase() === 'very good' ? 'blue' : 'green'
      :
      'black'
}